
import TableTextInput from './TableTextInput'
import TableDateInput from './TableDateInput'

import TableImageInput from './TableImageInput'
import TabelGlobalUserInput from './TabelGlobalUserInput'
import TablePhoneInput from './TablePhoneInput'
import TableMultiSelectInput from './TableMultiSelectInput'
import TableSelectInput from './TableSelectInput'
import TablePriceInput from './TablePriceInput'
// import TablePriceInput from './TablePriceInput'
import TableStatusIndicator from './TableStatusIndicator'
import TableProfitCalculator from './TableProfitCalculator'
import TableCalculator from './TableCalculator'
import TableNumberInput from './TableNumberInput'
import TableTextAreaInput from './TableTextAreaInput'
import TableSwitchInput from './TableSwitchInput'
import TableFileInput from './TableFileInput'
import TableEditorInput from './TableEditorInput'

const inputComponents = {
    // PhoneInput:TableTextInput,
    NumberInput:TableTextInput,
    PasswordInput:TableTextInput,
    TextInput:TableTextInput,
    SelectInput:TableSelectInput,
    TextAreaInput:TableTextInput,
    ProfileImageInput:TableTextInput,
    SelectListInput:TableTextInput,
    CheckboxInput:TableTextInput,
    FromToInput:TableTextInput,
    PriceInput:TablePriceInput,
    SliderInput:TableTextInput,
    AdvancedSelectInput:TableTextInput,
    MultiSelectInput:TableMultiSelectInput,
    ImageInput:TableImageInput,
    DateInput:TableDateInput,
    GlobalUserInput:TabelGlobalUserInput,
    PhoneInput:TablePhoneInput,
    SwitchInput:TableSwitchInput,
    NewStatusIndicator:TableStatusIndicator,
    StatusIndicator:TableStatusIndicator,
    ProfitCalculator:TableProfitCalculator,
    Calculator:TableCalculator,
    NumberInput:TableNumberInput,
    TextAreaInput:TableTextAreaInput,
    FileInput:TableFileInput,
    MultiLevelInput:TableMultiSelectInput,
    EditorInput:TableEditorInput

}

export default (inputComponents);